"use client";

import { Stub } from "@/composites/_internal";

/**
 * STUB — replaced in a subsequent ticket. See `docs/PDP_ARCHITECTURE.md`
 *
 * Intent: Pill row with optional icon per chip. Used by feature-highlight chips and transient_badges.
 */
export function ChipRow() {
	return (
		<Stub
			name="product/ChipRow"
			intent="Pill row with optional icon per chip. Used by feature-highlight chips and transient_badges."
		/>
	);
}
